/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
export default {
    upperLimitNoIsNull: { SC: "上限不能为空", TC: "上限不能為空", EN: "Upper Limit is required." }
    , download: { SC: "下载中...", TC: "下載中...", EN: "Downloading..." }
    , codeNoIsNull: { SC: "编码不能为空", TC: "編碼不能為空", EN: "Code is required." }
    , descriptionNoIsNull: { SC: "描述不能为空", TC: "描述不能為空", EN: "Description is required." }
    , activeIndNoIsNull: { SC: "是否激活不能为空", TC: "是否激活不能為空", EN: "Active is required." }
    , noIsNull: { SC: "不能为空", TC: "不能為空", EN: " is required." }
    , selectiveData: { SC: "请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." }
    , pleaseSelectAtLeastOneRecord: { SC: "请选择至少一条数据", TC: "請選擇至少一條數據", EN: "Please select at least one record." }
    , deleteData: { SC: "数据删除中...", TC: "數據删除中...", EN: "Data is processing..." }
    , deleteSuccess: { SC: "删除成功", TC: "刪除成功", EN: "Deleted successfully." }
    , beQuerying: { SC: "查询中...", TC: "査詢中...", EN: "Searching..." }
    , noneDate: { SC: "找不到符合条件记录.", TC: "找不到符合條件記錄.", EN: "No record is founed." }
    , saveSuccess: { SC: "保存成功", TC: "保存成功", EN: "Saved successfully." }
    , controls: { SC: "操作", TC: "操作", EN: "Operation" }
    , add: { SC: "Add", TC: "Add", EN: "Add" }
    , dataBeSaving: { SC: "数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }
    , withdrawnSuccess: { SC: "Withdrew successfully.", TC: "Withdrew successfully.", EN: "Withdrew successfully." }
    , approvalSuccess: { SC: "Approved successfully.", TC: "Approved successfully.", EN: "Approved successfully." }
    , rejectSuccess: { SC: "Rejected successfully.", TC: "Rejected successfully.", EN: "Rejected successfully." }
 
    , save: { SC: "Save", TC: "Save", EN: "Save" }
    , select: { SC: "Select", TC: "Select", EN: "Select" }
    , cancel: { SC: "Cancel", TC: "Cancel", EN: "Cancel" }
    , view: { SC: "View", TC: "View", EN: "View" }
    , delete: { SC: "Delete", TC: "Delete", EN: "Delete" }
    , audit: { SC: "Log", TC: "Log", EN: "Log" }
    , list: { SC: "List", TC: "List", EN: "List" }
    , search: { SC: "Search", TC: "Search", EN: "Search" }
    , reset: { SC: "Reset", TC: "Reset", EN: "Reset" }
    , update: { EN: "Edit" }
    , approve: { EN: "Approve" }
    , reject: { EN: "Reject" }
    , withdrawn: { EN: "Withdrawn" }
    , batchUpload: { EN: "Batch Upload" }
    , saveUpload: { EN: "Save & Upload" }
    , saveAsDraft: { EN: "Save as Draft" }
    , submit: { EN: "Submit" }
    , jobApplicationRecord: { EN: "Job Application Record" }
    , jobPosting: { EN: "Job Posting" }
    , studentInfo: { EN: "Student Academic Profile" }

    , studentID: { EN: "Student ID" }
    , studentName: { EN: "Student Name" }
    , studentEmail: { EN: "Email" }
    , industrialPartner: { EN: "Company Name" }
    , applyDate: { EN: "Date Student Submits Job App to MC" }
    , jobApplId : { EN: "Application Record" }
    , jobApplStatus: { EN: "Job App Status" }
    , jobId: { EN: "Job ID" }
    , jobTitle: { EN: "Job Title" }
    , positionType: { EN: "Job Mode" }
    , jobType: { EN: "Employment Type" }
    , otherDesc: { EN: "Other Description" }
    , programme: { EN: "Programme Code" }
    , programmeTitle: { EN: "Programme Name" }
    , salary: { EN: "Salary" }
    , unit: { EN: "Salary Basis" }
    , estimatedNoOfDaysAWeek: { EN: "Estimated no. of days a week" }
    , estimatedNoOfHoursAWeek: { EN: "Estimated no. of hours a week" }
    , expectDate: { EN: "Expect Date" }
    , startDate: { EN: "Start Date" }
    , endDate: { EN: "End Date" }
    , lastApplyDate: { EN: "Applied Date" }
    , workLocation: { EN: "Work Location" }
    , jobPostApprovedDate: { EN: "Job Post Approved Date" }
    , jobDesc: { EN: "Job Description" }
    , jobRequirement: { EN: "Job Requirement" }
    , firstName: { EN: "First Name" }
    , lastName: { EN: "Last Name" }
    , studentUserCode: { EN: "Student ID" }
 }